/* eslint-disable no-restricted-syntax */
/* eslint-disable class-methods-use-this */
/* eslint-disable camelcase */
import React, { Component } from 'react'
import classnames from 'classnames'
import moment from 'moment'
import { Button } from '@material-ui/core'
// import PhoneAndroidIcon from '@material-ui/icons/PhoneAndroid'
import DetailsEditor from './DetailsEditor'
import NlpViewer from './NlpViewer'
import IconEmail from '../../../../assets/icon-email.svg'
import IconSMS from '../../../../assets/icon-sms.svg'
import './index.scss'

const getSentDate = date => moment.unix(date / 1000).format('DD MMM, HH:mm')

class UserMessage extends Component {
    constructor(props) {
        super(props)

        this.state = {}
        this.messageBlockRef = React.createRef()
    }

    getMessage() {
        const { message, classifierResponse } = this.props

        let newMessage = message
        if (message) {
            const index = message.indexOf('If yes')
            if (index !== -1) {
                newMessage = message.substr(0, index)
            }
        }

        newMessage = newMessage ? newMessage.trim() : ''

        if (classifierResponse) {
            const parsedCR = JSON.parse(classifierResponse)
            const extractedGroups = parsedCR?.source_classifier_response?.extracted_groups
            if (extractedGroups) return this.highlightText(newMessage, extractedGroups)
        }
        return newMessage
    }

    getAuthor() {
        if (this.props.name && this.props.surname && !this.props.blacklisted) {
            return `${this.props.name} ${this.props.surname}`
        }
        return 'A customer'
    }

    getChannel() {
        return this.props.channel
    }

    highlightText(text, highlight = []) {
        const result = []
        let initialIndex = 0
        for (const range of highlight) {
            const { start_index, end_index } = range
            const starter = text.substring(initialIndex, start_index)
            const highlightedPart = text.substring(start_index, end_index)
            result.push(starter)
            result.push(<strong>{highlightedPart}</strong>)
            initialIndex = end_index
        }
        result.push(text.substring(initialIndex))
        return <span>{result}</span>
    }

    openDetailsPopup() {
        this.setState({ detailsOpened: true })
        this.props.onDetailsBoxChange(true)
    }

    closePopup() {
        this.setState({ detailsOpened: false })
        this.props.onDetailsBoxChange(false)
    }

    getOffsetTop() {
        if (!this.messageBlockRef.current) {
            return
        }
        const clientRect = this.messageBlockRef.current.getBoundingClientRect()
        return clientRect.top + clientRect.height
    }

    getOffsetLeft() {
        if (!this.messageBlockRef.current) {
            return
        }
        const clientRect = this.messageBlockRef.current.getBoundingClientRect()
        return clientRect.left
    }

    render() {
        const {
            detailsViewable,
            classifierResponse,
            oldClassifierResponse,
            blockClickListener,
        } = this.props
        const { detailsOpened, nlpViewerOpened } = this.state

        const messageBlockClassnames = classnames(
            {
                UserMessage__message__block: true,
                clickable: !blockClickListener,
            },
            `UserMessage__message__${this.getChannel()}`
        )
        const getAvatar = () => {
            const { channel } = this.props
            if (channel === 'email') {
                return (
                    <div style={{ margin: 5, paddingTop: '24px' }}>
                        <img src={IconEmail} />
                        {/* <EmailIcon style={{ color: 'rgb(60, 184, 240)' }} /> */}
                    </div>
                )
            }
            if (channel === 'sms') {
                return (
                    <div style={{ margin: 5, paddingTop: '24px' }}>
                        <img src={IconSMS} />
                        {/* <PhoneAndroidIcon style={{ color: 'rgb(60, 184, 240)' }} /> */}
                    </div>
                )
            }

            return <div className='UserMessage__message__avatar'></div>
        }
        // const { status } = this.props

        // const statusToRender = status ? <p className='NeutralStatus'>Status: {status}</p> : false
        // const { status } = this.props

        // let statusToRender
        // if (this.props.isConversation) {
        //     statusToRender = status ? <p className='NeutralStatus'>Status: {status}</p> : false
        // } else if (!status || status === 'ACTIVE_NEW_LEAD' || status === 'ACTIVE_ACTIVE_LEAD' || status === 'ACTIVE'
        //     || status === 'ACTIVE_WAITING_FOR_PROSPECT_RESPONSE') {
        //     statusToRender = (<p className='ActiveStatus'>Status Active</p>)
        // } else {
        //     statusToRender = (<p className='OffStatus'>Status Not Active</p>)
        // }

        return (
            <div className='UserMessage'>
                <div className='UserMessage__message'>
                    <div className='fixed-items'>
                        {getAvatar()}
                        <div>
                            <p className='UserMessage__sent-status'>
                                <span className={`author ${this.getChannel()}`}>
                                    {this.getAuthor()}
                                </span>
                                <span>{getSentDate(this.props.sent)}</span>
                            </p>
                            <div
                                className={messageBlockClassnames}
                                onClick={() => {
                                    if (blockClickListener) {
                                        return
                                    }
                                    this.setState({ nlpViewerOpened: true })
                                }}
                                ref={this.messageBlockRef}
                            >
                                <p>{this.getMessage()}</p>
                            </div>
                        </div>
                        {detailsViewable && (
                            <div className='UserMessage__details'>
                                <Button onClick={() => this.openDetailsPopup()}>
                                    &#x2935;
                                </Button>
                            </div>
                        )}
                    </div>
                    {/* {statusToRender} */}
                    {detailsOpened && (
                        <DetailsEditor
                            closePopup={() => this.closePopup()}
                            submitIntents={newIntents => this.props.submitIntents(newIntents)
                            }
                            classifierResponse={classifierResponse}
                        />
                    )}
                    {detailsOpened && (
                        <div
                            className='UserMessage__background'
                            onClick={() => this.closePopup()}
                        ></div>
                    )}
                </div>
                {nlpViewerOpened && (
                    <NlpViewer
                        classifierResponse={classifierResponse}
                        oldClassifierResponse={oldClassifierResponse}
                        nlpViewerClose={() => {
                            this.setState({ nlpViewerOpened: false })
                        }}
                    />
                )}
            </div>
        )
    }
}

export default UserMessage
